import React from 'react';

import MetricsGate from 'components/MetricsGate';
import ErrorBoundary from '../../components/Common/ErrorBoundary';
import visTypeCheckers from '../../types/visTypeCheckers';

import GeneralGoalProvider from './GeneralGoalProvider';

const GoalProvider = ({
  goal,
  children,
  isList,
}: {
  goal: GeneralGoal;
  children: JSX.Element | JSX.Element[];
  isList?: boolean;
}) => {
  if (visTypeCheckers.isGeneralGoal(goal)) {
    return (
      <ErrorBoundary>
        <MetricsGate content={goal} contentType="Goal">
          <GeneralGoalProvider goal={goal} isList={isList}>
            {children}
          </GeneralGoalProvider>
        </MetricsGate>
      </ErrorBoundary>
    );
  } else {
    return null;
  }
};

export default GoalProvider;
